import { render, staticRenderFns } from "./ResumePage.vue?vue&type=template&id=60c06dfb&scoped=true&"
import script from "./ResumePage.vue?vue&type=script&lang=js&"
export * from "./ResumePage.vue?vue&type=script&lang=js&"
import style0 from "./ResumePage.vue?vue&type=style&index=0&id=60c06dfb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c06dfb",
  null
  
)

export default component.exports